import { Schema } from 'rsuite'

const { StringType, NumberType, DateType } = Schema.Types

export const PromocodeFormValidationModel = Schema.Model({
  code: StringType()
    .isRequired('Заполните код')
    .minLength(4, 'Минимальное количество символов 4')
    .maxLength(20, 'Максимальное количество символов 20'),

  activeUntil: DateType().addRule(
    (value, data) => value > data.activeFrom,
    'Должно быть позже даты старта'
  ),
  activeFrom: DateType().addRule(
    (value, data) => !data.activeUntil || value < data.activeUntil,
    'Должно быть раньше даты завершения'
  ),

  deliveryDiscount: NumberType()
    .min(0, 'Не может быть отрицательным')
    .addRule(
      (value, data) => (data.deliveryDiscountInPercent ? value <= 100 : true),
      'Нельзя указать более 100%'
    ),
  cartDiscount: NumberType()
    .min(0, 'Не может быть отрицательным')
    .addRule(
      (value, data) => (data.cartDiscountInPercent ? value <= 100 : true),
      'Нельзя указать более 100%'
    ),
  maxOrderDiscount: NumberType()
    .min(0, 'Не может быть отрицательным')
    .addRule(
      (value, data) => (data.maxOrderDiscountInPercent ? value <= 100 : true),
      'Нельзя указать более 100%'
    ),

  minCartAmount: NumberType()
    .isRequired()
    .min(0, 'Не должно быть отрицательно'),
  activationLimit: NumberType()
    .isRequired()
    .addRule(
      (value, data) => (data.noActivationLimit ? true : value >= 0),
      'Не может быть отрицательным'
    ),
  userActivationLimit: NumberType()
    .isRequired()
    .addRule(
      (value, data) => (data.noUserActivationLimit ? true : value >= 0),
      'Не может быть отрицательным'
    )
})
